import React, {createRef} from 'react'
import ReactDOM from 'react-dom'
import PopoverContainer from "./popover-container"
import VScroll from "../scrolling/custom-v-scroll/v-scroll"
import {BUS_KEYBOARD_ESCAPE} from "../../gd/keyboard-shortcuts/keyboard-shortcuts";
import PopoverPosition from "./popover-position";
import {PopoverHeightRestriction} from "./@const";


type Props = {

    position                    : PopoverPosition,

    className?                  : string,
    style?                      : any
    children?                   : any

    rootSelector?               : string,

    popoverClass?               : string,
    popoverWith?                : number,      // if set will add width as a style

    popoverContentStyle?        : any,


    targetClass?                : string,  // class of element we want attach to


    onKeyDown?                  : callback,
    onMouseEnter?               : callback,
    onMouseLeave?               : callback,
    onClick?                    : callback,
    onClickOutside?             : callback,
    outsideClickIgnoreClass?    : string,
    clickOutsideEventTypes?     : any,
    clickOutsideDelay?          : number,
    onPopoverHide?              : callback,

    getTargetFunc?              : callback,
    onContainerReference?       : any,

    enableArrows?               : boolean,  // show arrows

    arrowsVersion?              : 1 | 2,
    arrowsCustomStyles?         : any   // example: {'bottom left bottom right': {background: white}}
                                        // template:
                                        // {'[tether-element-attached-top/bottom] [tether-element-attached-left/right]
                                        // [tether-target-attached-top/bottom] [tether-target-attached-left/right]': {*styles*}}
    fitTargetWidth?             : boolean,
    heightRestriction?          : PopoverHeightRestriction,     // max height of popover
    constraints?                : any[]




    autoVisibleTarget?          : boolean  // not in use I think safe to remove

}

const debug = false
// const debug = "Popover"

export default class PopoverV2 extends React.Component<Props> {

    public displayName      : string
    public _popoverElement  : any
    public _tether          : any

    private popoverArrowRef : any = createRef()
    private arrowStyle?     : any

    static defaultProps: Partial<Props> = {
        rootSelector: "body",

        // targetClass: "pop-target",

        constraints: [
            {
                to          : "window",
                attachment  : "together",
                pin         : true
            },
        ],

        enableArrows: true,
        arrowsVersion: 1,
        fitTargetWidth: false,
        outsideClickIgnoreClass: 'ignore-react-onclickoutside', // 'popover-container', //'ignore-react-onclickoutside',
        clickOutsideEventTypes: [/*'click', 'mouseup',*/ 'mousedown', 'touchstart'],
        clickOutsideDelay: 200,
        heightRestriction: PopoverHeightRestriction.NONE
    };

    constructor(props:Props) {
        super(props);

        this.displayName = "Popover";

        const popover = document.createElement( "span" );
        popover.className = Classes(props.popoverClass, props.position.attachmentType, "popover", {
            ['with-arrows arrows-version-{0}'.f(props.arrowsVersion)]: props.enableArrows,
        });


        if (props.popoverWith) {
            popover.style.width = props.popoverWith + 'px';
        }

        popover.onclick = (e)=>{if (props.onClick) props.onClick(e)};
        popover.onmouseenter = (e)=>{
            if (props.onMouseEnter) props.onMouseEnter(e)
        }
        popover.onmouseleave = (e)=>{if (props.onMouseLeave) props.onMouseLeave(e)};

        this._popoverElement = popover;

        // @ts-ignore
        document.querySelector(this.props.rootSelector).appendChild( this._popoverElement );
    }

    componentDidMount() {
        this._renderPopover();

        gd.bus.subscribe(BUS_KEYBOARD_ESCAPE, this, this.onKeyboardEscape)
    }

    componentDidUpdate() {
        this._renderPopover();
    }

    componentWillUnmount() {

        gd.bus.unsubscribe(this)

        if (this._tether) this._tether.destroy();
        ReactDOM.unmountComponentAtNode( this._popoverElement );
        if ( this._popoverElement.parentNode ) {
            this._popoverElement.parentNode.removeChild( this._popoverElement );
        }

        this.props.onPopoverHide?.()
    }

    // Experimental
    onKeyboardEscape = () => {
        const evt = {}
        this.props.onClickOutside && this.props.onClickOutside(evt)
    }

    onClickOutside = (evt:React.SyntheticEvent) => {
        if (this.props.onClickOutside) this.props.onClickOutside(evt);
    };

    onMouseEnter = (e:React.SyntheticEvent)=>{
        if (this.props.onMouseEnter) this.props.onMouseEnter(e)
    }

    _popoverComponent = (tetherOptions:any) => {
        let res;
        switch (this.props.heightRestriction) {
            case PopoverHeightRestriction.WINDOW_HEIGHT:
                res = <VScroll containerStyle={{maxHeight:window.innerHeight - 20}}>{this.props.children}</VScroll>
                break

            case PopoverHeightRestriction.HALF_WINDOW_HEIGHT:
                res = <VScroll containerStyle={{maxHeight:(window.innerHeight / 2) - 20}}>{this.props.children}</VScroll>
                break

            default:
                res = this.props.children;
                break
        }

        const showPopoverArrow = this.props.enableArrows && this.props.arrowsVersion === 2

        return (
            <PopoverContainer ref={this.props.onContainerReference}
                              eventTypes={this.props.clickOutsideEventTypes}
                              onClickOutside={this.onClickOutside}
                              outsideClickIgnoreClass={this.props.outsideClickIgnoreClass}
                              onKeyDown={this.props.onKeyDown}
                              tetherOptions={tetherOptions}
                              popoverProps={this.props}>
              <div className={Classes("popover-content", this.props.className)} style={this.props.popoverContentStyle}>
                  {showPopoverArrow && <div ref={this.popoverArrowRef} className="popover-arrow"/>}
                  {res}
              </div>
            </PopoverContainer>
        );
    };

    _updatePopoverArrow = (...args:any) => {
        debug && console.log(debug, '_updatePopoverArrow', args, this.props.arrowsCustomStyles)

        if (this.popoverArrowRef.current && this.props.arrowsCustomStyles) {
            const classes = this._tether.element.className

            debug && console.log(debug, '_updatePopoverArrow classes', classes)

            let styleNames = []
            if (classes.includes('tether-element-attached-top'))    styleNames.push('top')
            if (classes.includes('tether-element-attached-bottom')) styleNames.push('bottom')
            if (classes.includes('tether-element-attached-left'))   styleNames.push('left')
            if (classes.includes('tether-element-attached-right'))  styleNames.push('right')

            if (classes.includes('tether-target-attached-top'))     styleNames.push('top')
            if (classes.includes('tether-target-attached-bottom'))  styleNames.push('bottom')
            if (classes.includes('tether-target-attached-left'))    styleNames.push('left')
            if (classes.includes('tether-target-attached-right'))   styleNames.push('right')

            const arrowCustomStyleParamName = styleNames.join(' ')
            // if custom style is specified then set it
            const arrowStyle = this.props.arrowsCustomStyles[arrowCustomStyleParamName]

            debug && console.log(debug, '_updatePopoverArrow arrowStyle', _.isEqual(this.arrowStyle, arrowStyle), arrowStyle)

            if (_.isEqual(this.arrowStyle, arrowStyle)) return
            this.arrowStyle = arrowStyle

            if (arrowStyle) {
                debug && console.log(debug, '_updatePopoverArrow: set arrow custom style', arrowStyle)
                _.mapKeys(arrowStyle, (value, key) => {
                    this.popoverArrowRef.current.style.setProperty(key, value)
                })
            } else { // otherwise clear styles
                debug && console.log(debug, '_updatePopoverArrow: clear arrow style')
                this.popoverArrowRef.current.removeAttribute('style')
            }
        }
    }

    _tetherOptions = () => {
        let targetDOMNode;



        if (this.props.getTargetFunc) {
            targetDOMNode = this.props.getTargetFunc();
        } else if (this.props.targetClass) {
            // @ts-ignore
            targetDOMNode = ReactDOM.findDOMNode(this).parentElement.querySelector("." + this.props.targetClass);
        } else {
            // just parent...
            // @ts-ignore
            targetDOMNode = ReactDOM.findDOMNode(this).parentElement
        }


        return {
            element         : this._popoverElement,
            // @ts-ignore
            bodyElement     : document.querySelector(this.props.rootSelector),
            target          : targetDOMNode,
            attachment      : this.props.position.attachment,
            targetAttachment: this.props.position.targetAttachment,
            targetOffset    : this.props.position.targetOffset,
            offset          : this.props.position.offset,
            optimizations: {
                moveElement: false
            },
            constraints: this.props.constraints
        };
    };

    _renderPopover = () => {
        const tetherOptions = this._tetherOptions()
        if (!tetherOptions.target) return

        ReactDOM.render(
            this._popoverComponent(tetherOptions),
            this._popoverElement,
            ()=>{
                if ( this._tether != null ) {
                    this._tether.setOptions(tetherOptions);
                } else if ( window && document ) {
                    const Tether = require( "tether" );
                    this._tether = new Tether(tetherOptions);
                    this._tether.on('repositioned', this._updatePopoverArrow)
                }
                this._updatePopoverArrow()
            }
        )
    }

    render() {
        return <span/>;
    }
}
